import { render } from "./SubsidiesTablePerYear.vue?vue&type=template&id=3dcd0e8e"
import script from "./SubsidiesTablePerYear.vue?vue&type=script&lang=js"
export * from "./SubsidiesTablePerYear.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__